import React, { useState, useEffect } from "react";
import axios from 'axios';
import './../../styles/user/contacto.css';
import * as globals from './../../components/GlobalScripts.js';

const Contacto = () => {
    const user = globals.get_user();
    const [nombre, setNombre] = useState(user.nombre);
    const [correo, setCorreo] = useState(user.email);
    const [asunto, setAsunto] = useState('');
    const [mensaje, setMensaje] = useState('');

    let path_api = localStorage.getItem('path_api');

    const handleSubmit = async (e) => {
        e.preventDefault();

        const inputs = document.querySelector('form').querySelectorAll('input, textarea');
        let valid = true;

        inputs.forEach(input => {

            if (valid && !input.value.trim()) {
                globals.createAlert({ type: "error", msg_title: "Falta información", msg: `El campo ${input.name} es obligatorio.`, effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
                input.classList.add('requiered-outline');
                valid = false;
            } else if (valid) {
                input.classList.remove('requiered-outline');
            }
        });

        if (!valid) return;

        globals.openViewCharge();

        await axios.post(`${path_api}/user/contacto.php`, {
            nombre,
            correo,
            asunto,
            mensaje,
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin()
        }).then(response => {
            if (response.data.mensaje === "success") {
                globals.createAlert({ type: "success", msg_title: "Enviado", msg: "Tu mensaje ha sido enviado exitosamente.", effect: "opacidad 2s, desplazamiento 2s" });
                setNombre(user.nombre);
                setCorreo(user.email);
                setAsunto('');
                setMensaje('');
            } else if (response.data.mensaje) {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje, effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: "Si persiste, informe al soporte.", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Hubo un problema al enviar tu mensaje. Intenta de nuevo.", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });

        globals.closeViewCharge();
    };

    return (
        <div className='page-contacto container-section flex-column center gap-20'>
            <h1 className="no-margin">Enviame un mensaje</h1>

            <form onSubmit={handleSubmit}>
                <div className="group-column">
                    <label className="requiered-input">Nombre</label>
                    <input type="text" name="nombre" className="input-primary" value={nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Tu nombre" />
                </div>

                <div className="group-column">
                    <label className="requiered-input">Correo</label>
                    <input type="email" name="correo" className="input-primary" value={correo} onChange={(e) => setCorreo(e.target.value)} placeholder="tuemail@correo.com" />
                </div>

                <div className="group-column">
                    <label className="requiered-input">Asunto</label>
                    <input type="text" name="asunto" className="input-primary" value={asunto} onChange={(e) => setAsunto(e.target.value)} placeholder="Asunto del mensaje" />
                </div>

                <div className="group-column">
                    <label className="requiered-input">Mensaje</label>
                    <textarea name="mensaje" className="input-primary" value={mensaje} onChange={(e) => setMensaje(e.target.value)} placeholder="Escribe tu mensaje aquí..." rows="5"></textarea>
                </div>

                <div className="flex-row justify-end gap-20">
                    <button className="button-primary" type="submit">Enviar</button>
                </div>
            </form>
        </div>
    );
};

export default Contacto;
